import { render, staticRenderFns } from "./recommendationListing.vue?vue&type=template&id=74a65078&scoped=true&"
import script from "./recommendationListing.vue?vue&type=script&lang=js&"
export * from "./recommendationListing.vue?vue&type=script&lang=js&"
import style0 from "./recommendationListing.vue?vue&type=style&index=0&id=74a65078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a65078",
  null
  
)

export default component.exports